const buildContactForm = (base, reset) => {
	base = base || document

	let subscriptionMethodsToSubmit = [];
	const subscriptionMethodsContainer = base.querySelector('.js-contact-form-subscriptions-delivery-methods');
	const countryIdInput = base.querySelector('.js-countryId-input');

	const fetchCountries = (onSuccess) => {
		const request = new XMLHttpRequest();
	    request.open('GET', '/umbraco/api/Countries/Get', true);

	    request.onload = () => {
	        if (request.status >= 200 && request.status < 400) {
	            return onSuccess(JSON.parse(request.responseText));
	        }
	    }

	    request.send();
	}

	const fetchSubscriptionsDeliveryMethods = (onSuccess) => {
		const request = new XMLHttpRequest();
	    request.open('GET', '/umbraco/api/Subscriptions/GetDeliveryMethods', true);

	    request.onload = () => {
	        if (request.status >= 200 && request.status < 400) {
	            return onSuccess(JSON.parse(request.responseText));
	        }
	    }

	    request.send();
	}

	const focusOnErrors = (errorsContainer) => {
		const button = errorsContainer.querySelector('button');

		if (button) {
			button.focus();
		}

		if (base === document) {
			const scrollPosition = window.pageYOffset + errorsContainer.getBoundingClientRect().top;
			const topEl = document.querySelector('.navigation-bar-holder');
			const topHeight = scrollPosition - (topEl.clientHeight + 30);

			window.scroll(0, topHeight);

		} else {
			base.scrollTop = 0;
		}
	}

	const focusOnEl = (el) => {
		let focusTarget;

		if (el.tagName === 'INPUT' || el.tagName === 'SELECT') {
			focusTarget = el;
		} else {
			const button = el.querySelector('button');

			if (button) {
				focusTarget = button;
			}
		}

		if (focusTarget) {
			focusTarget.focus();
		}

		if (base === document) {
			const scrollPosition = window.pageYOffset + el.getBoundingClientRect().top;
			
			const elements = [
				document.querySelector('.navigation-bar-holder'),
				document.querySelector('.condition-sub-nav')
			];

			let elHeight = 0;

			elements.forEach(el => {
				if (el) {
					elHeight += el.clientHeight;
				}
			});

			const topHeight = scrollPosition - (elHeight + 30);
			
			window.scroll(0, topHeight);
		} else {
			base.scrollTop = 0;
		}
	}

	const validateForm = (form, onSuccess) => {
		const data = new FormData(form);
		const errorsContainer = form.querySelector('.js-contact-form-errors');
		let requiredFields = [];

		errorsContainer.innerHTML = null;

		for (let entry of data) {
			if (entry[0].indexOf('contact-') !== 0) {
				const input = form.querySelector('#contact-' + entry[0]);

				if (input) {
					const field = input.parentNode;
					const errorEl = field.querySelector('.js-contact-form-input-error');

					input.setAttribute('aria-invalid', false);
					field.classList.remove('field--error');

					if (errorEl) {
						errorEl.innerHTML = null;
					}

					if (input.getAttribute('aria-required') === 'true' && input.value === '') {
						requiredFields.push({
							input: input,
							type: 'required'
						});
						input.setAttribute('aria-invalid', true);
					} else {
						if (input.type === 'email' && !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(input.value)) {
							requiredFields.push({
								input: input,
								type: 'invalid'
							});
							input.setAttribute('aria-invalid', true);
						}
					}
				}
			}
		}

		if (requiredFields.length > 0) {
			let listHtml = ''

			requiredFields.forEach(item => {
				const field = item.input.parentNode;
				const label = field.querySelector('label')
				const errorEl = field.querySelector('.js-contact-form-input-error');

				field.classList.add('field--error');

				if (label) {
					listHtml += `<li class='js-contact-form-error' data-input='${item.input.id}'><button type="button">${label.dataset.label ? label.dataset.label : label.innerHTML} is ${item.type}</button></li>`
				}

				if (errorEl) {
					errorEl.innerHTML = `${label.dataset.label ? label.dataset.label : label.innerHTML} is ${item.type}`
				}
			});

			let html = `<p>Please fix the following errors before submitting.</p>`;

			if (listHtml !== '') {
				html += `<ul>${listHtml}</ul>`;
			}

			errorsContainer.innerHTML = html;

			focusOnEl(errorsContainer);

			form.querySelectorAll('.js-contact-form-error').forEach(error => {
				error.addEventListener('click', () => {
					const input = form.querySelector('#' + error.dataset.input);

					if (input) {
						input.focus();
						focusOnEl(input);
					}
				});
			});
		} else {
			onSuccess(data)
		}
	}

	const createContact = (data, onSuccess) => {
		const request = new XMLHttpRequest();
	    request.open('POST', '/umbraco/api/Contacts/Create', true);

	    let dataString = ''

	    for (let entry of data) {
	    	if (entry[0].indexOf('contact-') !== 0) {
				dataString += entry[0] + '=' + entry[1] + '&'
			}
		}

		dataString = dataString.slice(0, -1);

		request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

	    request.onload = () => {
	        if (request.status >= 200 && request.status < 400) {
	            const response = JSON.parse(request.response);
	            if (response && subscriptionMethodsContainer) {
	            	createSubscriptions(response.contactId, data, onSuccess);
	            } else {
	            	onSuccess();
	            }
	        }
	    }

	    request.send(dataString);
	}

	const createSubscriptions = (contactId, data, onSuccess) => {
		subscriptionMethodsToSubmit = [];

	    for (let entry of data) {
	    	if (entry[0].indexOf('contact-') === 0) {
	    		subscriptionMethodsToSubmit.push(entry[1]);
			}
		}

		if (subscriptionMethodsToSubmit.length > 0) {
			createSubscription(contactId, 0, onSuccess);
		} else {
			onSuccess();
		}
	}

	const createSubscription = (contactId, index, onSuccess) => {
		const request = new XMLHttpRequest();
	    request.open('POST', '/umbraco/api/Subscriptions/Create', true);

	    const deliveryMethodId = subscriptionMethodsToSubmit[index];

	    // let dataString = 'contactId=3be69c44-4cc2-ed11-b597-6045bd0d4896&deliveryMethodId=883f44b5-2152-e911-a85e-000d3a290633'
	    let dataString = `contactId=${contactId}&deliveryMethodId=${deliveryMethodId}`;

		request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

	    request.onload = () => {
	        if (request.status >= 200 && request.status < 400) {
		        if (index < subscriptionMethodsToSubmit.length - 1) {
		        	createSubscription(contactId, index + 1, onSuccess);
		        } else {
		        	onSuccess();
		        }
	        }
	    }

	    request.send(dataString);
	}

	const populateCountries = (countries) => {
		let options = '';

		countries.forEach(option => {
			options += `<option value='${option.countryId}'>${option.name}</option>`;
		})

		if (countryIdInput && options !== '') {
			countryIdInput.innerHTML = options;
		}
	}

	const populateSubscriptionsDeliveryMethods = (methods) => {
		let options = '';

		methods.forEach(option => {
			options += `<div class='field field--checkbox'>
                <input aria-required='false' ${option.name === 'Post' ? 'checked' : ''} aria-labelledby='l-${option.id}'' id='${option.id}' value='${option.id}' class='form-check-input' type='checkbox' name='contact-${option.name.toLowerCase()}'  aria-invalid='false'>
                <span class="field__helper">
					<img src="/Dist/images/checkbox-tick.svg" alt="" />
				</span>
                <label id='l-${option.id}' for='${option.id}'>${option.name}</label>
            </div>`;
		})

		if (subscriptionMethodsContainer && options !== '') {
			subscriptionMethodsContainer.innerHTML = options;
		}
	}

	const watchForm = () => {
		const form = base.querySelector('.js-contact-form');
		const fieldset = form.querySelector('fieldset');
		const button = document.querySelectorAll('.js-contact-form-start');

		if (form) {
			fieldset.removeAttribute('disabled');
			form.addEventListener('submit', (e) => {
				e.preventDefault();
				validateForm(form, (data) => {
					if (form.dataset.postBeforeSubmit === 'true') {
						form.method = 'post';

						form.submit();
					} else {
						fieldset.setAttribute('disabled', true);

						createContact(data, () => {
							fieldset.removeAttribute('disabled');
							
							const notification = form.querySelector('.js-contact-form-notification');

							if (notification) {
								notification.innerHTML = 'Submission Complete';
							}
						});
					}
				});
			});

			button.forEach(el => {
				el.addEventListener('click', () => {
					const input = form.querySelector('input, select, textarea');

					if (input) {
						input.focus();
						focusOnEl(input);
					}
				});
			});
		}
	}

	const init = () => {
		if (reset) {
			const form = base.querySelector('.js-contact-form');
			
			if (form) {
				const data = new FormData(form);

				for (let entry of data) {
					if (entry[0].indexOf('contact-') !== 0) {
						const input = form.querySelector('#contact-' + entry[0]);
						const field = input.parentNode;
						const errorEl = field.querySelector('.js-contact-form-input-error');

						input.value = null;
						input.setAttribute('aria-invalid', false);
						field.classList.remove('field--error');

						if (errorEl) {
							errorEl.innerHTML = null;
						}
					}
				}
						
				const errorsContainer = form.querySelector('.js-contact-form-errors')
				errorsContainer.innerHTML = null;
			}
		} else {
			if (countryIdInput) {
				fetchCountries(countries => {
					if (subscriptionMethodsContainer) {
						fetchSubscriptionsDeliveryMethods(methods => {
							populateCountries(countries);
							populateSubscriptionsDeliveryMethods(methods);
							watchForm();
						})
					} else {
						populateCountries(countries);
						watchForm();
					}
					
					// const request = new XMLHttpRequest();
				    // request.open('GET', '/umbraco/api/memberships/getpaymentfrequencies', true);

				    // request.onload = () => {
				    //     if (request.status >= 200 && request.status < 400) {
				    //         // return onSuccess(JSON.parse(request.responseText));
				    //     }
				    // }

				    // request.send();
					
					// const request2 = new XMLHttpRequest();
				    // request2.open('GET', '/umbraco/api/PaymentMethods/Get', true);

				    // request2.onload = () => {
				    //     if (request.status >= 200 && request.status < 400) {
				    //         // return onSuccess(JSON.parse(request.responseText));
				    //     }
				    // }

				    // request2.send();
					
					// const request4 = new XMLHttpRequest();
				    // request4.open('GET', '/umbraco/api/PaymentProcessors/Get', true);

				    // request4.onload = () => {
				    //     if (request.status >= 200 && request.status < 400) {
				    //         // return onSuccess(JSON.parse(request.responseText));
				    //     }
				    // }

				    // request4.send();
					
					// const request5 = new XMLHttpRequest();
				    // request5.open('GET', '/umbraco/api/Memberships/GetPriceLists', true);

				    // request5.onload = () => {
				    //     if (request.status >= 200 && request.status < 400) {
				    //         // return onSuccess(JSON.parse(request.responseText));
				    //     }
				    // }

				    // request5.send();
				})
			} else {
				watchForm();
			}
		}
	}

	init();
}

const theForm = document.querySelector('.js-contact-form')

if (theForm && theForm.clientWidth > 0) {
	buildContactForm()
} else {
	const popupButton = document.querySelectorAll('.js-contact-form-popup');
	const popupContent = document.querySelector('.js-contact-form-popup-content');

	if (popupButton && popupContent) {
		let activePopupButton;
		
		const modal = new tingle.modal({
		    stickyFooter: false,
		    closeMethods: ['overlay', 'button', 'escape'],
		    closeLabel: "Close",
    		cssClass: ['tingle-modal--full-mobile'],
		    beforeOpen: () => {
		    	const popupTitle = document.querySelector('.tingle-modal .js-contact-form-popup-title')

		    	if (popupTitle) {
		    		popupTitle.innerHTML = activePopupButton.dataset.title;
		    	}
		    },
		    onOpen: () => {
		        buildContactForm(document.querySelector('.tingle-modal'));
		        phoneNumber();
		    },
		    onClose: () => {
		        buildContactForm(document.querySelector('.tingle-modal'), true);
		    }
		});

		// set content
		modal.setContent(document.querySelector('.js-contact-form-popup-content').innerHTML);

		popupButton.forEach(button => {
			button.addEventListener('click', () => {
				activePopupButton = button
				modal.open();
			});
		});
	}
}